import React, { Component } from 'react';
import {   Row } from 'react-bootstrap';
import firebase from 'firebase/app';
import 'firebase/database';
import Item from "./Item"
import { DB_CONFIG } from './Config';

 
const app = firebase.initializeApp(DB_CONFIG);


class AllItems extends Component {

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  constructor(props, context) {
    super(props, context);

    this.handleShow = this.handleShow.bind(this);
    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false,

      items: [ 
      ] 

      

    };
    
    this.itemsDB =  app.database().ref().child('items'); 

  }

  componentDidMount() {
    this.itemsDB.on('value', snap => {
      let itemsConst = snap.val();
      let newData = [];
      for (let i in itemsConst) {
        if (itemsConst[i].remain >= 1){ 
          if(itemsConst[i].showInWebsite)  
             newData.push({
              id: itemsConst[i].id,
              name: itemsConst[i].name,
              code: itemsConst[i].code,
              showInWebsite: itemsConst[i].showInWebsite,
              websitePrice: itemsConst[i].websitePrice,
              desc: itemsConst[i].desc,
              category: itemsConst[i].category,
              quantity: itemsConst[i].quantity,
              remain: itemsConst[i].remain,
              imageURL: (itemsConst[i].imageURL !== "") ? itemsConst[i].imageURL : "https://www.simrad-yachting.com/assets/img/default-product-img.png?w=400&h=225&scale=both&mode=max"
            }
            );
            
          
      }
      this.setState({   items: newData  });

      //console.log(this.state.items);
    }
  
  
    
    

        


  });

    
  }


  render() {
    return (  
      <Row  >
         {    this.state.items.map((item) => <Item key={item.id} item={item}  app={app} />)}    
       </Row>
    );
  }
}

export default AllItems;
